import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { ABOUT, AI_TOPICS, FEATURED_COURSES, UPCOMING } from "@/data/content";
import { Section, Title, Reveal, Icon, CourseCard } from "@/components/site/ui";

export const About = () => (
  <Section id="about">
    <Title eyebrow="About Ilmora" title="Learning that respects" highlight="who you are" text="We started Ilmora for the girl who wants a career but also wants comfort, privacy and values. Here, skills meet sukoon." />
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {ABOUT.map((a, i) => (
        <Reveal key={a.title} delay={i * 0.1}>
          <div data-testid={`about-card-${i}`} className={`glass neon-card rounded-3xl p-7 h-full ${i % 2 ? "lg:mt-10" : ""}`}>
            <div className="icon-orb"><Icon name={a.icon} /></div>
            <h3 className="font-display text-xl font-semibold mt-5">{a.title}</h3>
            <p className="text-sm text-[var(--muted)] mt-2 leading-relaxed">{a.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);

export const AILearning = () => (
  <Section id="ai-learning">
    <div className="grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
        <Title eyebrow="AI Learning" title="Make AI your" highlight="study partner" center={false} text="Short, friendly lessons on the AI tools everyone is talking about, taught for real everyday use." />
        <Link to="/courses/content-creation" data-testid="ai-course-btn" className="btn-neon">Start Content Course <ArrowRight size={16} /></Link>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
        {AI_TOPICS.map((t, i) => (
          <Reveal key={t.title} delay={(i % 2) * 0.1}>
            <div data-testid={`ai-card-${i}`} className="glass neon-card rounded-3xl p-6 h-full flex gap-4">
              <div className="icon-orb shrink-0"><Icon name={t.icon} /></div>
              <div>
                <h3 className="font-display text-lg font-semibold">{t.title}</h3>
                <p className="text-sm text-[var(--muted)] mt-1 leading-relaxed">{t.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </Section>
);

export const TopCourses = () => (
  <Section id="top-courses">
    <div className="flex flex-wrap items-end justify-between gap-6">
      <Title eyebrow="Top Courses" title="Skills that open" highlight="new doors" center={false} />
      <Link to="/courses" data-testid="view-more-courses-btn" className="btn-ghost mb-8">View More <ArrowRight size={16} /></Link>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
      {FEATURED_COURSES.map((c, i) => <CourseCard key={c.slug} c={c} i={i} />)}
    </div>
  </Section>
);

export const Upcoming = () => (
  <Section id="upcoming">
    <Title eyebrow="Upcoming Courses" title="Fresh batches," highlight="coming soon" center />
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {UPCOMING.map((u, i) => (
        <Reveal key={u.title} delay={i * 0.1}>
          <div data-testid={`upcoming-card-${i}`} className="glass neon-card rounded-3xl overflow-hidden h-full">
            <div className="relative h-40">
              <img src={u.image} alt={u.title} className="w-full h-full object-cover opacity-80" />
              <span className="absolute top-3 right-3 bg-[var(--pink)] text-[var(--on-accent)] text-xs font-bold rounded-full px-3 py-1 shadow-[0_0_16px_var(--glow-pink)]">Coming Soon</span>
            </div>
            <div className="p-5">
              <p className="text-xs text-[var(--gold)] font-bold flex items-center gap-1"><Clock size={12} /> Launching {u.month}</p>
              <h3 className="font-display text-lg font-semibold mt-2">{u.title}</h3>
              <p className="text-sm text-[var(--muted)] mt-1">{u.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
